import { CardContent, Typography } from '@mui/material'
import type { Stripe, StripeElements } from '@stripe/stripe-js'
import React from 'react'

import type { Option } from '@/app/component/form/types'
import Loading from '@/app/component/guard/loading'
import { useGetCreditCards } from '@/app/module/payments/hooks/use-get-credit-cards'

import AddCreditCardForm from './add-credit-card-form'
import AddFundForm from './add-fund-form'

type Props = {
  amount?: number
  countries?: Option[]
  elements: StripeElements | null
  loading?: boolean
  error?: any
  minimum?: number | string
  stripe: Stripe | null
  user: { name: string; email: string }
}

const PaymentForm: React.FC<Props> = ({ amount, countries = [], elements, loading = false, error, stripe, user }) => {
  const { data: cardsData = [], isFetching: cardsFetching } = useGetCreditCards()
  const cards = React.useMemo<Option[]>(
    () => cardsData.map((c) => ({ value: String(c.id), label: c.label })),
    [cardsData],
  )

  const hasCard = !!cards.length
  const stripeLoaded = !!elements && !!stripe
  const isLoading = loading || cardsFetching

  return (
    <Loading isLoading={isLoading} error={error}>
      <CardContent>
        {!isLoading && (
          <>
            {!hasCard && (
              <>
                {!stripeLoaded && (
                  <Typography color="error">
                    We couldn't initialize the payment system. Please disable your ad blocker and try again.
                  </Typography>
                )}
                {stripeLoaded && (
                  <AddCreditCardForm countries={countries} elements={elements} stripe={stripe} user={user} />
                )}
              </>
            )}

            {hasCard && <AddFundForm amount={amount} cards={cards} />}
          </>
        )}
      </CardContent>
    </Loading>
  )
}

export default PaymentForm
